var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex terms"},[_c('a',{attrs:{"href":"https://hmc.co.il/wp-content/uploads/2024/07/מדיניות-פרטיות-אפליקצית-רופא.pdf","target":"_blank"}},[_vm._v(" מדיניות פרטיות ")]),_c('a',{attrs:{"href":"https://hmc.co.il/wp-content/uploads/2024/07/תנאי-שימוש-אפליקצית-רופא-1-1.pdf","target":"_blank"}},[_vm._v(" תנאי השימוש ")])])
}]

export { render, staticRenderFns }